module.exports = __webpack_public_path__ + "static/media/login-bg.d2810e4e.jpg";